import { path } from '../utils';
import { store } from '../main';

export const guc = (key , defaultVal) => path(store.getState(), `translationsReducer.universal_translations.${key}`, defaultVal);

export const gc = (translationKey, key) => path(store.getState(), `translationsReducer.${translationKey}.${key}`, '');

export const getCountryIsoCode = () => path(store.getState(), 'translationsReducer.country_iso_code');

export const getValueDirectlyFromTranslationsReducer = (key) => path(store.getState(), `translationsReducer.${key}`,'');
